import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Reactor from 'data/reactor';
import LCGetters from 'data/learning-continuum/getters';
import RuntimeActions from 'data/app-runtime/actions';
import DataUtils from 'data/utils';
import { DeepCompareComponentShouldUpdateMixin } from 'utils/react';

import NormalContent from './normal';
import ExpandedContent from './expanded/index';

export default CreateReactClass({
    displayName: 'InstructionalAreasContainer',
    mixins: [Reactor.ReactMixin, DeepCompareComponentShouldUpdateMixin],

    propTypes: {
        batchInfo: PropTypes.object /* Only exists when in Batch Print mode */,
        expandedModule: PropTypes.string,
        expandedSection: PropTypes.oneOf(['instruction', 'skills']),
        isSingleStudentMode: PropTypes.bool.isRequired,
        mode: PropTypes.oneOf(['normal', 'expanded']),
        selectedGoals: PropTypes.instanceOf(Immutable.List),
        selectedSubject: PropTypes.instanceOf(Immutable.Map),
        selectedTermNumber: PropTypes.number.isRequired,
        studentBid: PropTypes.string.isRequired,
        studentInfo: PropTypes.instanceOf(Immutable.Map),
        subject: PropTypes.instanceOf(Immutable.Map).isRequired,
        testEvents: PropTypes.instanceOf(Immutable.List).isRequired,
    },

    // --getDataBindings removal notes--
    // This is the only place in the entire application we use this getter. Moving it up wouldn't reduce the amount of times its called.
    // Handling this should be involved in the question "do we want to be loading our data in/out of {stateManagementTool} before passing it around?"
    getDataBindings() {
        return {
            lcData: LCGetters.learningContinuumData,
        };
    },

    setSelectedGoals(goals) {
        // this has to go in state, because the tile and expanded module do not have a common ancestor within IA.
        //    In fact, their closest common ancestor is /modules/index.jsx.
        RuntimeActions.selectInstructionalAreas(this.props.subject.get('bid'), goals);
    },

    /* TODO:CSN This is another area that has not been checked for CSN caveats and needed changes. In need of testing. */
    render() {
        const currentTestEvent = DataUtils.findTestEventForTermAndSubject(
            this.props.testEvents.valueSeq(),
            this.props.selectedTermNumber,
            this.props.subject.get('bid')
        );
        if (this.props.mode === 'normal') {
            return (
                <NormalContent
                    batchInfo={this.props.batchInfo}
                    currentTestEvent={currentTestEvent}
                    key="instructional-area-default-content"
                    selectGoals={this.setSelectedGoals}
                    studentBid={this.props.studentBid}
                    subjectBid={this.props.subject.get('bid')}
                />
            );
        } else if (!__BATCH__ || (this.props.batchInfo && this.props.batchInfo.batchIAGroupBy)) {
            return (
                <ExpandedContent
                    batchInfo={this.props.batchInfo}
                    currentTestEvent={currentTestEvent}
                    expandedModule={this.props.expandedModule}
                    isSingleStudentMode={this.props.isSingleStudentMode}
                    key="instructional-area-expanded-module"
                    lcData={this.state.lcData}
                    selectedGoals={this.props.selectedGoals}
                    selectedSubject={this.props.selectedSubject}
                    selectGoals={this.setSelectedGoals}
                    studentBid={this.props.studentBid}
                    studentInfo={this.props.studentInfo}
                    subject={this.props.subject}
                />
            );
        } else {
            // Don't include xIA if batch print doesn't require it.
            return null;
        }
    },
});
